export default "__VITE_ASSET__CCD28WMd__"